import './Cards.css';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

function Cards() {
  return (
    <section className="cards">
      <header className="cards__header">
        <h1>Bendrijos naujienos</h1>
      </header>
      <div className="cards__container">
        <ul className="cards__list">
          <li className="cards__item">
            <Card className="customCard pinkCard" elevation={3}>
              <CardContent>
                <div class="cards__intro">
                  <span class="cards__date cards__date--centered-bold">2025-11-29 15 val.</span>

                  <br />
                  SB „Piliakalnis“ vandenvietės teritorijoje organizuojamas neeilinis bendrijos narių visuotinis
                </div>

                <Typography variant="h5" fontWeight="bold" className="cards__title" gutterBottom>
                  <h1>SUSIRINKIMAS</h1>
                </Typography>

                <div className="cards__agenda">
                  <Typography variant="subtitle1" fontWeight="medium">
                    Darbotvarkė:
                  </Typography>
                  <ul className="cards__bulletlist">
                    <li>Gyvenamojo namo Pilies 1-oji Nr. 8 elektros įrenginių prijungimo prie skirstomųjų tinklų projekto derinimas.</li>
                    <li>Einamieji klausimai</li>
                  </ul>
                </div>

                <p class="cards__note">
                  Neįvykus pirmajam susirinkimui, pakartotinis susirinkimas bus šaukiamas 2025-12-13 15 val.
                  <span class="cards__signature">Valdyba</span>
                </p>
              </CardContent>
            </Card>
          </li>
        </ul>
      </div>
    </section>
  );
}

export default Cards;
